import { render, staticRenderFns } from "./SwitchOrders.vue?vue&type=template&id=05ed0393"
import script from "./SwitchOrders.vue?vue&type=script&lang=js"
export * from "./SwitchOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports